<template>
  <section class="container flex justify-center">
    <div
      class="flex justify-center mx-auto webcam"
      id="roundshot-thumbnail-6ccfb5bda1782df03a473f51b9a5b13a"
    ></div>
  </section>
</template>

<script setup>
onMounted(() => {
  const script = document.createElement('script');
  script.src = 'https://backend.roundshot.com/js/roundshot_animated_thumbnail.js';
  script.async = true;
  // append script to the document head
  document.head.appendChild(script);

  setTimeout(() => {
    window.roundshot.animate({
      id: '6ccfb5bda1782df03a473f51b9a5b13a',
      picture: 'https://backend.roundshot.com/cams/6ccfb5bda1782df03a473f51b9a5b13a',
      link: 'https://sils.roundshot.com/',
      angle: 360,
      width: 1600,
      height: 400,
      bounce: false,
      open_in_new_tab: true,
      speed: 18
    });
  }, 500);
});
</script>

<style lang="postcss">
.rs-img-6ccfb5bda1782df03a473f51b9a5b13a {
  @apply !my-auto !mx-auto;
}

.webcam {
  & > div {
    @apply scale-[4] lg:scale-[2.2] !h-[250px]  md:!h-[400px];
  }
  img {
    object-fit: contain !important;
  }
}

#roundshot-thumbnail-6ccfb5bda1782df03a473f51b9a5b13a {
  @apply w-[95%] overflow-hidden;
}
</style>
